import { SystemStyleObject } from "@mui/system";
import { COLORS } from "../../../../constants";

interface StyleProps {
  sizeData: {
    padding: string;
    fontSize: string;
    legend: string;
    label?: string;
  };
  defaultAdornmentColors?: boolean;
  multiline?: boolean;
}

/**
 * label styles
 */
export const inputLabelSxPropsFn = ({
  sizeData,
}: StyleProps): SystemStyleObject => ({
  fontSize: sizeData.fontSize,
  transform: `translate(14px, ${sizeData.label}) scale(1)`,
  "&.MuiInputLabel-shrink": {
    transform: "translate(14px, -9px) scale(0.75)",
  },
});

/**
 * Input styles
 */
export const inputSxPropsFn = ({
  sizeData,
  defaultAdornmentColors,
  multiline,
}: StyleProps): SystemStyleObject => ({
  "&:hover": {
    "& svg": {
      color: defaultAdornmentColors ? COLORS.P_MED_EMPHASIS : undefined,
    },
  },
  svg: {
    color: defaultAdornmentColors ? COLORS.P_DISABLED : undefined,
  },
  "&.Mui-error .MuiOutlinedInput-notchedOutline": {
    borderColor: COLORS.SATURATED_RED,
  },
  "&.Mui-focused": {
    "& svg": {
      color: defaultAdornmentColors ? COLORS.P_MED_EMPHASIS : undefined,
    },
  },
  ".MuiOutlinedInput-notchedOutline": {
    "& legend": {
      fontSize: sizeData.legend,
    },
  },
  ".MuiOutlinedInput-input": {
    paddingTop: multiline ? 0 : sizeData.padding,
    paddingBottom: multiline ? 0 : sizeData.padding,
    fontSize: sizeData.fontSize,
  },
});
